<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4221_1368)">
      <path
        d="M9.75 20.2496V14.2496H14.25V20.2496H20.25V11.2496C20.2501 11.1511 20.2307 11.0535 20.1931 10.9625C20.1555 10.8714 20.1003 10.7887 20.0306 10.719L12.5306 3.21899C12.461 3.14926 12.3783 3.09394 12.2872 3.05619C12.1962 3.01845 12.0986 2.99902 12 2.99902C11.9014 2.99902 11.8038 3.01845 11.7128 3.05619C11.6217 3.09394 11.539 3.14926 11.4694 3.21899L3.96938 10.719C3.89975 10.7887 3.84454 10.8714 3.8069 10.9625C3.76926 11.0535 3.74992 11.1511 3.75 11.2496V20.2496H9.75Z"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_4221_1368">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: "House",
  props: {
    width: {
      type: [String, Number],
      default: 24,
    },
    height: {
      type: [String, Number],
      default: 24,
    },
    color: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>

<style></style>